'use client';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, Copy } from 'lucide-react';
import { toast } from 'sonner';

export const CopyButton = ({ text }: { text: string }) => {
  const [clicked, setClicked] = React.useState(false);

  const handleClickButton = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 2000);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard');

    handleClickButton();
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="text-foreground [&_svg]:size-3 w-7 h-7"
      onClick={handleCopy}
    >
      {clicked ? <Check className="text-green-300" /> : <Copy />}
    </Button>
  );
};
